import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getMfaIssueDetails } from 'src/apps/mfa/services/MfaSingleSessionService';
import { MFA_ISSUE_DETAILS } from 'src/common/providers/reactQueryProvider/QueryKeys';
import { MobileIssueDetails } from 'src/common/types/MobileSingleSessionTypes';

export const useMfaIssueDetailsQuery = (
	issueId: string,
	runId: string
): UseQueryResult<MobileIssueDetails> => {
	const componentSampleIssueQuery = useQuery([MFA_ISSUE_DETAILS, issueId, runId], () =>
		getMfaIssueDetails(issueId, runId)
	);

	return componentSampleIssueQuery;
};
